<div class="delete-modal">
  <mat-dialog-content class="mat-typography text-center">
    <h2 mat-dialog-title class="text-center">Error Occured</h2>
    <p>{{message}}</p>
    <!--<h2 mat-dialog-title class="text-center">
      Delete
      <span class="font-weight-bold text-uppercase">{{ local_data.name }}</span>
      ?
    </h2> -->
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-raised-button class="btn text-danger cancel" mat-dialog-close (click)="onCancel()">
     Cancel
    </button>
  </mat-dialog-actions>
</div>
